import React from 'react';
import VideoBanner from './VideoBanner';
import { Card } from 'antd';

const NoPermissionBanner = () => {
  return (
    <Card style={{ fontSize: '16px' }}>
      <div style={{ display: 'flex', gap: '20px', minHeight: '30vh', minWidth: '80vw' }}>
        <div style={{ flex: 1 }}>
          <p>
            You do not have permission to use Nexa. Please contact your admin to enable Nexa for
            you.
          </p>
        </div>
        <VideoBanner />
      </div>
      <div></div>
    </Card>
  );
};

export default NoPermissionBanner;
